import React, { useState, useEffect } from "react";
import { Select, MenuItem, FormControl } from "@mui/material";
import { getDirectorEmployee } from "../../../http/api/MasterAPI";

const DirectorEmployeeSelect = ({ onChange, value }) => {
  const [listDirectorEmployee, setListDirectorEmployee] = useState([]);
  const [selectedValue, setSelectedValue] = useState(value || "-1");

  async function getListDirectorEmployee() {
    try {
      const response = await getDirectorEmployee();
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          directorEmployeeId: element.varCd,
          directorEmployeeName: element.varValue1,
        }))
        .filter(
          (x) => x.directorEmployeeName && x.directorEmployeeName.trim() !== ""
        );
      setListDirectorEmployee(result);
    } catch (error) {
      console.error("担当者を取得するとき不具合発生した。", error);
    }
  }

  useEffect(() => {
    getListDirectorEmployee();
  }, []);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelectionChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <>
      <Select
        value={selectedValue}
        onChange={handleSelectionChange}
        sx={{ width: 400, marginInline: 1 }}
      >
        <MenuItem key="unselected" value="-1">
          [未選択]
        </MenuItem>
        {listDirectorEmployee.map((item) => (
          <MenuItem
            key={item.directorEmployeeId}
            value={item.directorEmployeeId}
          >
            {item.directorEmployeeName}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default DirectorEmployeeSelect;
